export const config = {
  debug: true
}